<template>
  <div>
    <div class="logManage div-layout">
      <module-title title="系统日志" />
      <main>
        <el-form
          ref="departManage-search-form"
          :model="searchForm"
          :inline="true"
          label-position="right"
          label-width="100px"
        >
          <div>
            <el-form-item label="选择终端" prop="status">
              <el-select
                v-model="searchForm.terminalId"
                placeholder="请选择"
                class="edit-form-input"
                @change="handleTerminal"
              >
                <el-option label="全部" value="" />
                <el-option
                  v-for="(item) in terminalOptions"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="日志模块" prop="status">
              <el-select
                v-model="searchForm.logColumn"
                placeholder="请选择"
                class="edit-form-input"
                @change="handleLog"
              >
                <el-option label="全部" value="" />
                <el-option
                  v-for="(item) in logOptions"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
          </div>
        </el-form>
        <BaseTable
          v-loading="listLoading"
          class="list-table"
          :columns="columns"
          :data="dataList"
          border
        />
        <pagination
          :total="pageObj.total"
          :page.sync="pageObj.currentPage"
          :limit.sync="pageObj.pageSize"
          @pagination="handleCurrentChange"
          @handleSizeChange="handleSizeChange"
        />
      </main>
    </div>
  </div>
</template>

<script>

import { sysLogList, terminalList, columnList } from '@/api/systemManage/systemLog/logManage';
import { columns } from './store';
export default {
  data() {
    return {
      // 查询条件
      searchForm: {
        terminalId: null,
        logColumn: null
      },
      pageObj: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      terminalOptions: [],
      logOptions: [],
      //   表格
      listLoading: false,
      columns,
      dataList: []
    };
  },
  created() {
    this.getWhiteList();
    this.iniData();
  },
  methods: {
    iniData() {
      terminalList().then((res) => {
        if (res.data) {
          this.terminalOptions = res.data;
        }
      });
      columnList().then((res) => {
        if (res.data) {
          this.logOptions = res.data;
        }
      });
    },
    // 获取数据
    getWhiteList() {
      this.listLoading = true;
      const { currentPage, pageSize } = this.pageObj;
      const params = {
        ...this.searchForm,
        pageNum: currentPage,
        pageSize
      };
      sysLogList(params)
        .then((res) => {
          this.listLoading = false;
          const data = res.data;
          if (data) {
            this.dataList = data.list || [];
            this.pageObj.total = data.total || 0;
          }
        })
        .catch((error) => {
          this.listLoading = false;
          console.log(error);
        });
    },
    // 下拉框触发
    handleTerminal() {
      this.getWhiteList();
    },
    handleLog() {
      this.getWhiteList();
    },
    // pageSize 改变时会触发
    handleSizeChange(obj) {
      this.pageObj.currentPage = 1;
      this.pageObj.pageSize = obj.limit;
      this.getWhiteList();
    },
    // currentPage 改变时会触发
    handleCurrentChange(obj) {
      this.pageObj.currentPage = obj.page;
      this.pageObj.pageSize = obj.limit;
      this.getWhiteList();
    }
  }
};
</script>
<style lang='scss' scoped>
</style>
